const features = [
  {
    icon: 'ri-flashlight-line',
    title: '即点即播',
    desc: '无需等待缓冲，点击即刻播放，智能预加载技术让观影零延迟，高清视频秒开不卡顿。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免注册观看',
    desc: '无需手机号、无需邮箱、无需任何注册流程，打开网站即可畅享全部影视资源，隐私安全无忧。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持标清到4K多清晰度选择，HDR优化让画面色彩更真实，细节表现更出众，带来影院级视觉享受。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量资源',
    desc: '收录超过30000部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等多种类型，每日持续扩充。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '全面兼容电脑、平板、手机等设备，自适应屏幕尺寸，支持投屏至电视大屏，随时随地畅享影视。',
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            平台优势
          </h2>
          <p className="text-foreground-600 text-sm mt-2 max-w-lg mx-auto">五大核心优势，打造极致观影体验，让每一次观影都成为享受</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((feat, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 border border-background-200/60 flex flex-col items-center text-center gap-3 cursor-default"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 text-2xl">
                <i className={feat.icon}></i>
              </span>
              <h3 className="font-heading text-base font-bold text-foreground-900">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}